import { useEffect, useState } from "react";
import { Container, Heading } from "../../global";
import { PressureDot } from "./styles";

const PressureDots = ({
  color1,
  color2,
  score1,
  score2,
  scoreToWin,
  title,
}) => {
  scoreToWin = parseInt(scoreToWin);
  score1 = parseInt(score1);
  score2 = parseInt(score2);
  const [scoreDots, setScoreDots] = useState();
  useEffect(() => {
    const tempScore = [];
    for (let i = 0; i < scoreToWin; i++) {
      if (score1 > i) {
        tempScore.push(<PressureDot color={color1.card} key={i} />);
      } else if (i + score2 < scoreToWin) {
        tempScore.push(<PressureDot key={i} />);
      } else {
        tempScore.push(<PressureDot color={color2.card} key={i} />);
      }
    }
    setScoreDots(tempScore);
  }, [score1, score2]);
  return (
    <Container $flex={1}>
      <Container style={{ transform: "rotate(270deg)" }}>
        <Heading $size={"10px"} style={{ textWrap: "nowrap" }}>
          {title}
        </Heading>
      </Container>
      <Container $flex={1} $gap={"4px"}>
        {scoreDots}
      </Container>
      <Container style={{ transform: "rotate(90deg)" }}>
        <Heading $size={"10px"} style={{ textWrap: "nowrap" }}>
          {title}
        </Heading>
      </Container>
    </Container>
  );
};

export default PressureDots;
